
import React from "react";
import PropTypes from "prop-types";
import { useRef, useState, useEffect } from "react";
import LoginMobileHeader from "../../../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../../../components/header/InstituteMobileHeader";
import CRMobileHeader from "../../../components/header/CRMobileHeader";
import MobileHeader from "../../../components/header/MobileHeader";
import LoginHeader from "../../../components/header/LoginHeader";
import InstituteHeader from "../../../components/header/InstituteHeader";
import CRHeader from "../../../components/header/CRHeader";
import NonLoginHeader from "../../../components/header/NonLoginHeader";
import Companydetails from "./Companydetails";
import Footer from "../../../components/footer";
import Gotop from "../../../components/gotop";
import RecruiterDetails from "./RecruiterDetails";

CompanyDetailMain.propTypes = {};

const marKers = [
    {
        id: 1,
        title: "Rockstar Games New York",
        name: "Senior UI/UX Designer",
        address: "Las Vegas, NV 89107, USA",
        longitude: -74.00122,
        latitude: 40.71023,
        // img: lo1,
    },
];

function CompanyDetailMain(props) {
    const progressRef = useRef();
    const [targetHeight, setTargetHeight] = useState(0);
    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const [isShowMobile, setShowMobile] = useState(false);

    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };

    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        if (progressRef?.current) {
            const offsetHeight = progressRef?.current?.offsetTop;
            setTargetHeight(offsetHeight);
        }
    }, [progressRef]);

    // ...............................Job Details.......................................

    // ...............................Job Details.......................................
    const module = localStorage.getItem('Module')
    return (
        <>
            {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader clname="" handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader clname="" handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader clname="" handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader clname="" handleMobile={handleMobile} /> :
                            <NonLoginHeader clname="" handleMobile={handleMobile} />}

            <div className="pt-70">
                <RecruiterDetails />
                <Footer />
                <Gotop />
            </div>
        </>
    );
}

export default CompanyDetailMain;



